import React, { Component } from "react";
import moment from "moment";
class NotFoundScreen extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    return (
      <div
        style={{
          display: "flex",
          flex: 1,
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          // height: "100vh",
          // width: "100vw",
        }}
      >
        <div
          style={{
            fontSize: "100px",
            fontWeight: "bold",
            color: "white",
          }}
        >
          404
        </div>
        <div
          style={{
            fontSize: "30px",
            fontWeight: "bold",
            color: "white",
          }}
        >
          Page Not Found
        </div>
      </div>
    );
  }
}

export default NotFoundScreen;
